import { initializeApp } from "firebase/app";
import { getDatabase, onValue, ref, remove, set } from "firebase/database";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  getFirestore,
  updateDoc,
} from "firebase/firestore";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  databaseURL: process.env.REACT_APP_DATA_BASE_URL,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};
const app = initializeApp(firebaseConfig);

// Get a reference to the database service
const database = getDatabase(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
export const signInWithGoogle = async () => {
  const res = await signInWithPopup(auth, provider);
  console.log(res)
};

export const writeToDataBase = (data, idNumber) => {
  // here to add argument of id and put it instead of the library uniuqid
  set(ref(database, "/" + idNumber), data);
};
export const updateDB = (data, id) => {
  // here the id is the key to update the sane user or product in this case
  set(ref(database, "/" + id), data);
};
export const deleteData = (id) => {
  console.log(ref);
  remove(ref(database, id));
};

export function readData(cb) {
  onValue(ref(database), (snapshot) => {
    const data = snapshot.val();
    cb(data);
    console.log(data.length);

   if (!data) {
      console.log("no data");
    }
  });
}

// from here its the firestore v9
export const fireStoreDB = getFirestore(app);
export const orderCollectionRef = collection(fireStoreDB, "/orders");
export const createOrder = async (order) => {
  console.log(order);
  const doc = await addDoc(orderCollectionRef, { order });
  console.log(doc.id);
};
export const updateOrder = async (id, updateOrder) => {
  const orderDoc = doc(fireStoreDB, "orders", id);
  await updateDoc(orderDoc, updateOrder);
};
export const deleteOrder = async (id) => {
  console.log(id);
  const orderDoc = doc(fireStoreDB, "orders", id);
  await deleteDoc(orderDoc);
};

export default database;
